// extracted by mini-css-extract-plugin
module.exports = {"head":"style_head__agy9V","title":"style_title__2DA_X","time":"style_time__LTwaL","content":"style_content__GaP4J","tabs":"style_tabs__2dCNg"};